import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import $ from "jquery";

import { loader_image } from "../_components/Imagepath";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const ViewDailyProductionReports = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(61)); 
      console.log(permission);

  
    axios
      .get(`/daily-production-reports/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.report);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

 
  const handleDownload = async () => {
       let season_id = localStorage.getItem("season_id");

    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    axios.get(`/daily-production-reports/pdf/${season_id+'-'+id}`, {
       responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
   }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let file_name = 'Daily-Production-Report.pdf';
        link.download = file_name;
        link.click();
        $("#loader-image").addClass('loader-hide');
        $("#loader-image").removeClass('loader-show');
    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
    });
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Daily Report</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-daily-reports">
                        Production Daily Reports
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Production Daily Report
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.list == 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Production Daily Report Info</h4> <hr/>
                    <div style={{float:"right"}}>
                      <button   onClick={() => handleDownload()}   className="btn btn-primary me-1"  > Download Report <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>  </button>
                    </div>
                    <table className="table table-bordered">
                      <tbody>
                      <tr>
                        <th className="p-3">Date</th>
                        <td className="p-3">{value.date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name.title : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Raw Material Consumption</th>
                        <td className="p-3">
                          {value.raw_material_consumption}(KG)
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Report Status</th>
                        <td className="p-3"> {value.report_status? value.report_status_title.title: ""} </td>
                      </tr>
                      </tbody>
                   
                    </table>
                  </div>
                )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.list == 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Details</h4> <hr/>
                  
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="p-3">Pallet Type</th>
                          <th className="p-3">Numbers of Pallets</th>
                          <th className="p-3">Net Weight</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th className="p-3">Finished Pallets</th>
                          <td className="p-3">{value.finished_pallets}</td>
                          <td className="p-3">{value.finished_products_net_weight}(KG)</td>
                        </tr>
                        <tr>
                          <th className="p-3">Decay</th>
                          <td className="p-3">{value.decay}</td>
                          <td className="p-3">{0}(KG)</td>
                        </tr>
                        <tr>
                          <th className="p-3">Pending Pallets</th>
                          <td className="p-3">{value.pending_pallets}</td>
                          <td className="p-3">{0}KG</td>
                        </tr>
                        <tr>
                          <th className="p-3">Return</th>
                          <td className="p-3">{0}</td>
                          <td className="p-3">{value.return}(KG)</td>
                        </tr>
                        <tr>
                          <th className="p-3">Small Calibers</th>
                          <td className="p-3">{0}</td>
                          <td className="p-3">{value.small_calibers}(KG)</td>
                        </tr>
                      
                      </tbody>
                   
                    </table>
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewDailyProductionReports;
